import Transform from './Base';

export default class UserTransform extends Transform {
  /**
   * Method used to transform a fetched user profile.
   *
   * @param profile The fetched user profile.
   *
   * @returns {Object} The transformed user profile.
   */
  static fetch(user) {
    return {
      full_name: !!user.user ? user.user.name : 'guest',
      language: 'en',
      // id: profile.id,
      // tenant_id: profile.tenant_id,
      // email: profile.email.toLowerCase(),
      // login: profile.login,
      // first_name: profile.first_name,
      // last_name: profile.last_name,
      // full_name: `${profile.first_name} ${profile.last_name}`.trim(),
      // role: profile.role,
      // language: profile.language,
      // is_buyer: profile.is_buyer,
    };
  }
}
